import "./personalDetails.css"
import React, {useEffect, useState} from "react";
import TextBox from "../TextBox/TextBox";
import CustomDatePicker from "../DatePicker/DatePicker";
import {dateStringToISO} from "../../utils";
import CustomSelectBox from "../CustomSelectBox/CustomSelectBox";
import {isValidPhoneNumber} from "react-phone-number-input/mobile";
import AccountsService from "../../../../services/AccountsService";
import CardValidationService from "../../../../services/CardValidationService";
import {useLoading} from "../../../../context/LoadingContext";
import PinVerification from "../../../PinVerification/PinVerification";
import PopUp from "../../../Utilities/PopUp";
import {useTranslation} from "react-i18next";
function PersonalDetails({formData, setFormData,userData, setUserData, updateFields, phoneNumberVerify, setPhoneNumberVerify, updateUserData}){
    const {removeLoading, addLoading} = useLoading();

    const { t } = useTranslation();

    const [referer, setReferer] = useState(null);
    const ant1grReferer = "ant1gr"

    const handleInputChange = (name, value) => {
        setFormData(prev => {
            return {...prev, [name]: {value: value, error: false}}
        });
    };
    const setFieldError = (name, isError) => {
        setFormData(prev => {
            if (Array.isArray(name)) {
                const updatedFormData = {...prev};
                name.forEach(field => {
                    if (updatedFormData[field]) {
                        updatedFormData[field] = {
                            ...updatedFormData[field],
                            error: isError
                        };
                    }
                });
                return updatedFormData;
            } else {
                return {
                    ...prev, [name]: {
                        value: prev[name].value,
                        error: isError
                    }
                }
            }
        })

    };

    const getFieldError = (name)  =>{
        return formData[name]?.error;
    }
    const getFieldValue = (name) =>{
        return formData[name]?.value;
    }
    const [isEditing, setIsEditing] = useState(false)


    const getUpdatedFields = () =>{
        const diffs = {};
        Object.keys({ ...userData, ...formData }).forEach(key => {
            if(formData.hasOwnProperty(key)) {
                if ((!!userData[key] && userData[key] !== getFieldValue(key)) ||
                    (!userData[key] && !!getFieldValue(key))) {
                    if (key === "phoneNumber") {
                        if(isValidPhoneNumber(getFieldValue(key)))
                            updatePhoneNum(getFieldValue(key));
                        else
                            setFieldError("phoneNumber", true);
                        return;
                    }
                    diffs[key] = getFieldValue(key);
                }
            }
        });
        return diffs;
    }

    const anyErrors = () =>{
        return Object.keys(formData).some(key => formData[key].error);
    }

    const updatePhoneNum = (phoneNum) => {
        addLoading("ACCOUNTPERSONALSUBMITPHONE");
        AccountsService.patchUser({"phoneNumber": phoneNum})
            .catch(error => {
                if (error.response.data.code === 403) {
                    if(error.response.data.token){
                        sessionStorage.setItem("cardValidationToken", error.response.data.token)
                        CardValidationService.generateOTP({phoneNumber: phoneNum,}, error.response.data.token)
                            .then((response) => {
                                setPhoneNumberVerify(true);
                                sessionStorage.setItem("phoneVerificationToken", response.data.token);
                            })
                            .catch((error) => {
                                //todo error return from back
                                console.log("Failure: generateOTP")
                            })
                            .finally(()=> {
                                console.log(getFieldValue("phoneNumber"));
                                removeLoading("ACCOUNTPERSONALSUBMITPHONE")
                            })
                    }
                }
            })
    }



    const handlePersonalSubmit = () =>{
        const fields = getUpdatedFields();
        if(Object.keys(fields).length === 0){
            return;
        }
        addLoading("ACCOUNTPERSONALSUBMIT");
        setIsEditing(false);
        AccountsService.patchUser(Object.entries(fields)
            .filter(([key, value]) => value  && value.trim() !== '')
            .reduce((acc, [key, value]) => {
                acc[key] = value;
                return acc;
            }, {}))
            .then((nousage)=>{
                updateUserDataPersonalDetails()
                    .finally(()=>{
                        removeLoading("INIT")
                        removeLoading("ACCOUNTPERSONALSUBMIT")
                    })
            })
            .catch((error) => {
                if(error.response.data.code === 101){
                    setFieldError(error.response.data?.fields, true)
                    setIsEditing(true)
                }else{
                }
            })
            .finally(()=>{
                removeLoading("ACCOUNTPERSONALSUBMIT")
            });
    }

    const phoneNumberCodes = [
        {text: "GR", code: "+30"},
        {text: "CY", code: "+357"},
    ]
    const closeEdit = ()=>{
        updateFields(userData)
        setIsEditing(false)
    }

    const closeEditIfNoError = ()=>{
        if(!anyErrors()){
            setIsEditing(false);
        }
    }

    useEffect(() => {
        setIsEditing(anyErrors())

        let kc_Token = sessionStorage.getItem("kc_tok")
        if(kc_Token){
            kc_Token = JSON.parse(kc_Token)
            setReferer(kc_Token.referer ?? null)
        }
    }, []);//eslint-disable-line react-hooks/exhaustive-deps

    const updateUserDataPersonalDetails = async () => {
        return updateUserData()
            .finally(()=>{
                closeEditIfNoError();
            })
            .finally(()=>{
                removeLoading("INIT")
                removeLoading("ACCOUNTPINVERIFICATIONSUCCESS")
            })
    }

    const getGenderValue = ()=>{
        const value = getFieldValue("gender");
        switch(value){
            case "Γυναίκα":
                return "accountPersonalDetailsGenderFemale"
            case "Άντρας":
                return "accountPersonalDetailsGenderMale";
            case "Άλλο":
                return "accountPersonalDetailsGenderOther";
            default:
                return null;
        }
    }
    const getSanitizedGenderValue = (value) =>{
        switch(value){
            case "accountPersonalDetailsGenderFemale":
                return "Γυναίκα"
            case "accountPersonalDetailsGenderMale":
                return "Άντρας"
            case "accountPersonalDetailsGenderOther":
                return "Άλλο"
            default:
                return "Άλλο";
        }
    }

    return(<>
        <div className={"account-personal-data"}>
            <div className={"account-personal-data-header"}>
                <span className={"account-personal-data-title"}>{t("accountPersonalDetails")}</span>
                {!isEditing ?
                    <span className={"account-personal-data-header-edit"} onClick={() => {
                        setIsEditing(true)
                    }}>{t("accountPersonalDetailsEdit")}</span>
                    :
                    <div className={"account-personal-data-header-isEditing account-desktop"}>
                        <span className={"account-personal-data-header-cancel"}
                              onClick={closeEdit}>{t("accountPersonalDetailsCancel")}</span>
                        <span className={"account-personal-data-header-edit"}
                              onClick={handlePersonalSubmit}>{t("accountPersonalDetailsSave")}</span>
                    </div>
                }
            </div>
            <div className={"account-personal-data-wrapper"} onDoubleClick={() => {
                setIsEditing(true)
            }}>
                <div className={"account-textboxes-grouped"}>
                    <TextBox fieldTitle={t("accountPersonalDetailsFirstName")} fieldName={"firstName"}
                             defaultValue={getFieldValue("firstName")}
                             isError={getFieldError("firstName") ?
                                 <span>${t("accountPersonalDetailsNotAcceptableCharacters")}</span> : undefined}
                             onChange={(e) => {
                                 handleInputChange(e.target.name, e.target.value)
                             }} disabled={!isEditing}/>
                    <TextBox fieldTitle={t("accountPersonalDetailsLastName")} fieldName={"lastName"}
                             defaultValue={getFieldValue("lastName")}
                             isError={getFieldError("lastName") ?
                                 <span>${t("accountPersonalDetailsNotAcceptableCharacters")}</span> : undefined}
                             onChange={(e) => {
                                 handleInputChange(e.target.name, e.target.value)
                             }} disabled={!isEditing}/>
                </div>
                {referer !== ant1grReferer ?
                    <>
                        <div className={"account-textboxes-grouped"}>
                            <CustomDatePicker key={getFieldValue("dateOfBirth")} fieldTitle={t("accountPersonalDetailsDateOfBirth")} onChange={(date) => {
                                handleInputChange("dateOfBirth", date)
                            }} defaultValue={dateStringToISO(getFieldValue("dateOfBirth"))} disabled={!isEditing}/>
                            <CustomSelectBox fieldTitle={t("accountPersonalDetailsGender")} fieldName={"gender"}
                                             defaultValue={getGenderValue()}
                                             customOnChange={(value) => {
                                                 handleInputChange("gender", getSanitizedGenderValue(value))
                                             }} disabled={!isEditing}
                                             options={["accountPersonalDetailsGenderFemale", "accountPersonalDetailsGenderMale", "accountPersonalDetailsGenderOther"]}
                                             placeholder={t("accountPersonalDetailsGenderPlaceholder")}/>
                        </div>
                        <div className={"account-textboxes-grouped"}>
                            <TextBox fieldTitle={t("accountPersonalDetailsPhoneNum")} fieldName={"phoneNumber"}
                                     type={"phoneNumber"}
                                     defaultValue={getFieldValue("phoneNumber")} isError={getFieldError("phoneNumber") ?
                                <span>Το τηλέφωνο δεν είναι έγκυρο</span> : undefined} onChange={(value) => {
                                handleInputChange("phoneNumber", value)
                            }} disabled={!isEditing} options={phoneNumberCodes}/>
                            <span className={"account-textbox-placeholder"}>{isEditing ? "" : ""}</span>
                        </div>
                    </>:<></>
                }
            </div>
            {isEditing &&
                <div className={"account-mobile"}>
                    <div className={"account-personal-data-header-isEditing"}>
                        <span className={"account-personal-data-header-cancel"}
                              onClick={closeEdit}>{t("accountPersonalDetailsCancel")}</span>
                        <span className={"account-personal-data-header-edit"}
                              onClick={handlePersonalSubmit}>{t("accountPersonalDetailsSave")}</span>
                    </div>
                </div>
            }

        </div>
        <PopUp
            openPopUp={phoneNumberVerify}
            setOpenPopUp={(isOpen) => {
                setPhoneNumberVerify(isOpen);
                if (!isOpen) {
                    handleInputChange("phoneNumber", '');
                    setIsEditing(true);
                }
            }}
            maxWidth="md"
            showCloseButton={true}
            outlined={false}
            error={false}
            closeWhenClickedOutside={true}
        >
            <PinVerification
                showBackButton={false}
                isModal={true}
                mobile={getFieldValue("phoneNumber")}
                successAction={(token) => {
                    addLoading("ACCOUNTPINVERIFICATIONSUCCESS")
                    AccountsService.patchUser({phoneNumber: getFieldValue("phoneNumber"), flowToken: token})
                        .then((nousage) => {
                            updateUserDataPersonalDetails()
                                .finally(() => {
                                    setPhoneNumberVerify(false)
                                    closeEditIfNoError();
                                    removeLoading("INIT")
                                    removeLoading("ACCOUNTPINVERIFICATIONSUCCESS")
                                })
                        })
                        .catch((err) => {

                        })
                        .finally(() => {
                            removeLoading("ACCOUNTPINVERIFICATIONSUCCESS")
                        })
                }}
            />
        </PopUp>
    </>)
}

export default PersonalDetails;